import React, { useState } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { LuSquareArrowOutUpRight } from "react-icons/lu";

function Bitcoinmarket({ data, itemsPerPage, currentPage, setCurrentPage }) {
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = data.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  return (
    <>
      <h4 className="d_white pt-3">Bitcoin Markets</h4>
      <Table responsive className="fulllist text-center">
        <thead>
          <tr>
            <th>S.no</th>
            <th>Exchange</th>
            <th>Symbols</th>
            <th>Pair</th>
            <th>Price</th>
            <th>Volume (24h)</th>
            <th>Volume %</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item, index) => (
            <tr key={index} className="listing_coin">
              <td>{offset + index + 1}</td>
              <td>
                {item?.exchangeData?.name} 
                {/* <span className="shortname">{item.shortname}</span> */}
              </td>
              <td>
                <img src={item.logo} className="coin" alt="bnb" />
              </td>
              <td>
                {item.base_currency}/{item.target_currency}{" "}
                <span className="arrowlist">
                  <LuSquareArrowOutUpRight />
                </span>
              </td>
              <td>{item.price}</td>
              <td>{item.volume}</td>
              <td>{item.volumeper?.current}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ReactPaginate
        previousLabel={<MdOutlineKeyboardArrowLeft />}
        nextLabel={<MdOutlineKeyboardArrowRight />}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </>
  );
}

export default Bitcoinmarket;
